import React from 'react';

const highlights = [
  { icon: '🚀', label: '20+ Years' },
  { icon: '🏢', label: 'Enterprise Platforms' },
  { icon: '🤖', label: 'GenAI' },
  { icon: '☁️', label: 'Cloud & Azure' },
  { icon: '📊', label: 'Digital Transformation' },
];

const ExecutiveSummary = () => {
  return (
    <div className="summary-section">
      <div className="summary-highlights">
        {highlights.map((h, i) => (
          <span key={i} className="summary-pill">
            <span className="pill-icon">{h.icon}</span> {h.label}
          </span>
        ))}
      </div>
      <div className="summary-text">
        <p>
          I turn complex business challenges into scalable digital solutions. Over 20 years,
          I've delivered high-impact transformations across retail, fintech, property management,
          and enterprise IT — from architecting Azure cloud migrations to launching GenAI-powered
          platforms that drive real revenue.
        </p>
        <p>
          My sweet spot is bridging the gap between business vision and technical execution.
          Whether it's rebuilding a CRM ecosystem that becomes the corporate backbone, shipping
          an eCommerce platform that converts, or integrating AI into daily workflows — I bring
          a bias for action and a track record of shipping on time.
        </p>
        <p>
          I thrive in fast-moving environments where strategy meets delivery. I build and mentor
          cross-border teams, navigate stakeholder dynamics at every level, and keep projects
          focused on outcomes that matter. If you need someone who can own the problem end-to-end
          and deliver results — let's talk.
        </p>
      </div>
    </div>
  );
};

export default ExecutiveSummary;
